import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFluentFavorites = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 19,
	viewBox: "0 0 20 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 0.5L12.5206 6.71885H19.0595L13.7694 10.5623L15.7901 16.7812L10.5 12.9377L5.20993 16.7812L7.23056 10.5623L1.94049 6.71885H8.47937L10.5 0.5Z",
		stroke: "#A0A0A0",
		strokeWidth: 1.1
	})
});
export default SvgFluentFavorites;
